/** Component to input a location, or display an existing location.
 * As input, it takes the existing selection
 */

import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { Map, List } from "immutable";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { findLocationByName, findLocationDetailByID } from "../api";
// See: http://ericgio.github.io/react-bootstrap-typeahead/#asynchronous-searching

class LocationInput extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      options: []
    };
  }

  render() {
    // FIXME consider having reverse geocoding service too
    const { location, className, placeholder } = this.props;
    const { isLoading, options } = this.state;

    // Styling problem: Probably because we have an invisible input inside a virtual input,
    // in order to support a "tags" type of interface.

    return (
      <AsyncTypeahead
        onFocus={e => e.target && e.target.select()}
        useCache={true}
        className={className}
        isLoading={isLoading}
        options={options}
        labelKey="name"
        selected={location ? [location.getIn(["address", "namedAddress"])] : undefined}
        minLength={2}
        onSearch={this.onSearch.bind(this)}
        placeholder={placeholder}
        renderMenuItemChildren={(location = {}) => (
          <div className="airport">
            <div className="name">{location.name}</div>
          </div>
        )}
        onChange={this.onChange.bind(this)}
      />
    );
  }

  onSearch(query) {
    this.setState({
      isLoading: true
    });
    findLocationByName(query).then((locationResults = List()) => {
      this.setState({
        options: locationResults.toJS(),
        isLoading: false
      });
    });
  }

  onChange([newLocation = {}]) {
    if (newLocation.name) {
      const { location } = this.props;
      if (newLocation.gpsLocation === undefined) {
        findLocationDetailByID(newLocation.locationIdentifier[0].identifier).then((gpsLocation = {}) => {
          newLocation.gpsLocation = gpsLocation.get("geoLocation").toJS();
          if (
            location == null ||
            (location.get("geoLocation").get("latitude") !== newLocation.gpsLocation.latitude &&
              location.get("geoLocation").get("longitude") !== newLocation.gpsLocation.longitude)
          ) {
            console.log("setting new location");
            const { onChange } = this.props;
            if (onChange) {
              onChange(
                Map.of(
                  "name",
                  newLocation.name,
                  "gpsLocation",
                  Map.of("latitude", newLocation.gpsLocation.latitude, "longitude", newLocation.gpsLocation.longitude),
                  "locationIdentifier",
                  newLocation.locationIdentifier[0].identifier
                )
              );
            }
          }
        });
      } else if (
        location == null ||
        (newLocation.gpsLocation &&
          location.get("geoLocation").get("latitude") !== newLocation.gpsLocation.latitude &&
          location.get("geoLocation").get("longitude") !== newLocation.gpsLocation.longitude)
      ) {
        const { onChange } = this.props;
        if (onChange) {
          onChange(
            Map.of(
              "name",
              newLocation.name,
              "gpsLocation",
              Map.of("latitude", newLocation.gpsLocation.latitude, "longitude", newLocation.gpsLocation.longitude),
              "locationIdentifier",
              newLocation.locationIdentifier[0].identifier
            )
          );
        }
      }
    }
  }
}

LocationInput.propTypes = {
  location: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  // One or more new airports are discovered.
  // :: Seq<Map> -> ()
  className: PropTypes.string,
  placeholder: PropTypes.string
};

export default LocationInput;



// WEBPACK FOOTER //
// ./src/ndc/request/LocationInput.js